import { connect } from 'react-redux';
import ProPageComponent from '../components/ProPageComponent';
import { fetchProPageFaqsIfNeeded } from '../actions/ProPageAction';

const mapStateToProps = (state) => ({
    proPageFaqs: state.proPage.proPageFaqs,
});

const mapDispatchToProps = (dispatch) => ({
    fetchProPageFaqsIfNeeded: () => dispatch(fetchProPageFaqsIfNeeded()),
});

const ProPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProPageComponent);

export default ProPageContainer;
